import OapDsfAppSkindrWrapper from './code/Scripts/components/OapDsfAppSkindrWrapper/OapDsfAppSkindrWrapper.vue';

export default {
  components: {
    OapDsfAppSkindrWrapper,
  },
};
